import { render, staticRenderFns } from "./RichContentDisplay.vue?vue&type=template&id=69dc7fae&scoped=true"
import script from "./RichContentDisplay.vue?vue&type=script&lang=js"
export * from "./RichContentDisplay.vue?vue&type=script&lang=js"
import style0 from "./RichContentDisplay.vue?vue&type=style&index=0&id=69dc7fae&prod&lang=scss&scoped=true"
import style1 from "./RichContentDisplay.vue?vue&type=style&index=1&id=69dc7fae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69dc7fae",
  null
  
)

export default component.exports